const day = ['月', '火', '水', '木', '金', '土', '日'];

export const formatCharacter = {
    formatJapaneseCurrency: new Intl.NumberFormat('ja-JP', {
      style: 'currency',
      currency: 'JPY',
      minimumFractionDigits: 0
    })
};

export const getDayFromDateTime = (num) => {
  return day[num - 1];
} 

